<template>
  <h1 id="page-title">Configurações</h1>
  <div v-if="!changePwd" class="config">
    <div class="deleteAccount">
      <el-button type="danger" @click="handleUserDeletion"
        >Deletar Conta</el-button
      >
    </div>
    <div class="changePassword">
      <el-button type="warning" @click="showUpdatePwdForm"
        >Alterar Senha</el-button
      >
    </div>
  </div>

  <div v-else class="passwordForm">
    <el-form ref="form" :model="user">
      <el-form-item>
        <el-input
          placeholder="Digite sua senha atual"
          v-model="user.current_password"
          show-password
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-input
          placeholder="Digite sua nova senha"
          v-model="user.new_password"
          show-password
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-input
          placeholder="Digite sua nova senha novamente"
          v-model="user.new_password_confirmation"
          show-password
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button id="change-pwd-button" type="primary" @click="handlePwdReset"
          >Alterar senha</el-button
        >
      </el-form-item>

      <el-form-item>
        <div v-if="changePwdSuccess">
          <el-alert type="success" effect="dark">
            Senha alterada com sucesso!
          </el-alert>
        </div>
        <div v-else-if="wrongCurrentPwd">
          <el-alert type="warning" effect="dark">
            A senha atual não está correta
          </el-alert>
        </div>
        <div v-else-if="wrongPwdConfirmation">
          <el-alert type="warning" effect="dark">
            A nova senha e a confirmação da nova senha não são iguais
          </el-alert>
        </div>
        <div v-else-if="changePwdError">
          <el-alert type="error" effect="dark">
            Houve um erro ao redefinir a senha
          </el-alert>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { deleteOwnUser } from "../../services/user";
import { updatePwd } from "../../services/user";

export default {
  name: "Comments",
  components: {},

  data() {
    return {
      user: {},
      changePwd: false,
      changePwdSuccess: false,
      wrongCurrentPwd: false,
      wrongPwdConfirmation: false,
      changePwdError: false,
    };
  },

  methods: {
    async handleUserDeletion() {
      const shouldDelete = await this.$confirm(
        "Tem certeza que deseja deletar sua conta?",
        "Atenção",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      );
      if (shouldDelete) {
        deleteOwnUser()
          .then(() => {
            this.$store.commit("userStatus", {
              loggedInfo: "NOT_LOGGED_IN",
              userData: {},
            });
            this.$router.push(`/`);
          })
          .catch((error) => {
            console.log("user deletion error", error);
          });
      }
    },

    handlePwdReset() {
      this.changePwdSuccess = false;
      this.wrongCurrentPwd = false;
      this.wrongPwdConfirmation = false;
      this.changePwdError = false;
      updatePwd(this.user)
        .then((response) => {
          if (response.status == 200) {
            this.changePwdSuccess = true;
          }
        })
        .catch((error) => {
          console.log("change password error", error);
          switch (error.response.status) {
            case 401:
              this.wrongCurrentPwd = true;
              break;
            case 422:
              this.wrongPwdConfirmation = true;
              break;
            default:
              this.changePwdError = true;
          }
        });
    },

    showUpdatePwdForm() {
      this.changePwd = true;
    },
  },
};
</script>
<style scoped>
.config {
  text-align: center;
}

.changePassword {
  margin-top: 10px;
}

#page-title {
  text-align: center;
}

.passwordForm {
  text-align: center;
  padding-left: 10%;
  padding-right: 10%;
}

#change-pwd-button {
  float: right;
}
</style>
